<div class="columns small-12 medium-8">
  <p data-cy="homeGatewayDescription">
    {{ 'internet.settings.home.gateway.description' | translate }}
  </p>
  <button
    href="javascript:void(0)"
    (click)="goToHomeGatewaySite()"
    class="rs-btn"
    data-cy="homeGatewayButton"
    data-tms-action-name="advanced modem settings"
    attr.data-tms-button-name="{{ 'internet.settings.home.gateway.button' | translate }}"
  >
    {{ 'internet.settings.home.gateway.button' | translate }}
  </button>
</div>
